import React from "react";
import { faArrowTurnRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DisplaySkill from "./DisplaySkill";

const Skill = ({ skills, title }) => {
  return (
    <div className="flex flex-row items-center mb-[50px] flex-wrap">
      <div className="text-teal-100 font-medium text-[30px] mr-[50px]">
        {title}
        <FontAwesomeIcon
          icon={faArrowTurnRight}
          width={40}
          className="ml-[50px]"
        />
      </div>
      {skills.map((skill, index) => (
        <>
          <DisplaySkill skill={skill} key={index} />
        </>
      ))}
    </div>
  );
};

export default Skill;
